/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import SplitterInserterConfiguration from 'embercom/objects/series/node/splitter-inserter-configuration';

export default class WaitNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new SplitterInserterConfiguration();
  category = NODE_CATEGORIES.action;
}
